import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pdl-10 pdr-10 mt-30" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-20" }, "Create Your Own Report", -1)
const _hoisted_3 = {
  key: 1,
  class: "bordered-card bordered-card_secondary mt-20"
}
const _hoisted_4 = { class: "d-flex justify-content-between align-items-md-center w-100 mb-10 flex-md-row flex-column sm-gap-20" }
const _hoisted_5 = {
  key: 0,
  class: "sm-fs-sm"
}
const _hoisted_6 = { class: "d-flex gap-5 flex-md-row flex-column" }
const _hoisted_7 = { class: "w-100 text-center sm-fs-xs" }
const _hoisted_8 = { class: "d-flex w-100 justify-content-between mt-10 flex-md-row flex-column sm-gap-10" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  width: "20"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  version: "1.1",
  id: "L9",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 0 0",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFFFFF",
    d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      dur: "1s",
      from: "0 50 50",
      to: "360 50 50",
      repeatCount: "indefinite"
    })
  ])
], -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_LocalReportStep1 = _resolveComponent("LocalReportStep1")!
  const _component_LocalReportStep2 = _resolveComponent("LocalReportStep2")!
  const _component_LocalReportStep3 = _resolveComponent("LocalReportStep3")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, { errors: $setup.errors }, null, 8, ["errors"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_MessageCard, {
        message: $setup.messageCardInfo,
        type: "primary",
        iconClass: "iatse-icon-alarm",
        classes: "info_card__page"
      }, null, 8, ["message"]),
      ($setup.loading)
        ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.steps, (step) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: step.id
                }, [
                  ($setup.currentStep === step.id)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(step.label), 1))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.steps, (step) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: step.id,
                    class: _normalizeClass(['fw-semibold', 'ribbon', $setup.currentStep === step.id ? 'active text-white' : 'text-dark', $setup.currentStep > step.id ? 'completed text-white' : 'text-dark'])
                  }, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(step.label), 1)
                  ], 2))
                }), 128))
              ])
            ]),
            ($setup.currentStep === 1)
              ? (_openBlock(), _createBlock(_component_LocalReportStep1, {
                  key: 0,
                  filters: $setup.filters.FilterFields,
                  inputErrors: $setup.inputErrors,
                  onUpdateFilters: $setup.updateFilterFields,
                  "saved-templates": $setup.savedTemplatesOptions,
                  template: $setup.selectedTemplate,
                  onChangeTemplate: $setup.useSavedTemplate
                }, null, 8, ["filters", "inputErrors", "onUpdateFilters", "saved-templates", "template", "onChangeTemplate"]))
              : _createCommentVNode("", true),
            ($setup.currentStep === 2)
              ? (_openBlock(), _createBlock(_component_LocalReportStep2, {
                  key: 1,
                  fields: $setup.filters.SelectedFields,
                  onUpdateFields: $setup.updateSelectedFields
                }, null, 8, ["fields", "onUpdateFields"]))
              : _createCommentVNode("", true),
            ($setup.currentStep === 3)
              ? (_openBlock(), _createBlock(_component_LocalReportStep3, {
                  key: 2,
                  loadingSubmit: $setup.loadingSubmit,
                  sorting: $setup.filters.SortedFields,
                  columns: $setup.columns,
                  onUpdateColumns: $setup.updateColumns,
                  onUpdateSorting: $setup.updateSortedFields,
                  template: $setup.selectedTemplate,
                  onSaveTemplate: $setup.saveTemplate
                }, null, 8, ["loadingSubmit", "sorting", "columns", "onUpdateColumns", "onUpdateSorting", "template", "onSaveTemplate"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              ($setup.currentStep > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-sm btn-secondary lh-1",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goToPreviousStep && $setup.goToPreviousStep(...args))),
                    disabled: $setup.loadingSubmit
                  }, "Back", 8, _hoisted_9))
                : _createCommentVNode("", true),
              ($setup.currentStep === 3)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-sm btn-secondary lh-1 ml-20 sm-ml-0",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.resetForm && $setup.resetForm(...args))),
                    disabled: $setup.loadingSubmit
                  }, "Reset", 8, _hoisted_10))
                : _createCommentVNode("", true),
              ($setup.currentStep < 3)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-primary btn-submit ms-auto",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.goToNextStep && $setup.goToNextStep(...args))),
                    disabled: $setup.loadingSubmit
                  }, " Next ", 8, _hoisted_11))
                : ($setup.currentStep === 3)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      class: "btn btn-primary plan-modal btn-submit lh-1 w-sm-100 ms-auto",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.submitReport && $setup.submitReport(...args))),
                      disabled: $setup.loadingSubmit
                    }, [
                      _createTextVNode(" Run Report and Download "),
                      ($setup.loadingSubmit)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_15))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_12))
                  : _createCommentVNode("", true)
            ])
          ]))
    ])
  ], 64))
}